import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { CheckEmployeeRequestResponse } from '@qaroni-app/check/types/check-employee-request';
import { ApiQWorkardsEnv } from '@qaroni-core/config/apis/api-qworkards/api-qworkards.config';
import { RequestSummariesCountApiObject } from '../types/request-summaries-count';
import { ScheduleRequestsMultiple } from '../types/schedule-requests-multiple';

@Injectable({
  providedIn: 'root',
})
export class ScheduleRequestsHttpService {
  private http = inject(HttpClient);

  public getAllRequests$(companyID: number, params?: Params) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/checks/requests`;

    return this.http.get<CheckEmployeeRequestResponse>(url, { params });
  }

  public approveRequest$(
    companyID: number,
    employeeID: number,
    requestID: number
  ) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/employees/${employeeID}/checks/requests/${requestID}/approve`;

    return this.http.patch<CheckEmployeeRequestResponse>(url, {});
  }

  public rejectRequest$(
    companyID: number,
    employeeID: number,
    requestID: number
  ) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/employees/${employeeID}/checks/requests/${requestID}/reject`;

    return this.http.patch<CheckEmployeeRequestResponse>(url, {});
  }

  public counter$(companyID: number, params?: Params) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/checks/requests/summaries/counter`;

    return this.http.get<RequestSummariesCountApiObject>(url, { params });
  }

  public approveMultipleRequests$(
    companyID: number,
    request: ScheduleRequestsMultiple
  ) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/employees/checks/requests/approves`;

    return this.http.patch<CheckEmployeeRequestResponse>(url, request, {
      observe: 'response',
    });
  }

  public rejectMultipleRequests$(
    companyID: number,
    request: ScheduleRequestsMultiple
  ) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/employees/checks/requests/rejects`;

    return this.http.patch<CheckEmployeeRequestResponse>(url, request, {
      observe: 'response',
    });
  }
}
